import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  fetchBoqById,
  fetchItemHistoryByDate,
  fetchItemHistory,
  addBoqItemExecution,
  fetchExecutionHistoryByDate,
  deleteBoqItem,
  uploadBoqItemFileApi,
  fetchBoqItemFilesApi,
  deleteBoqItemFileApi,
  fetchHistoryBoqItem,
  viewBoqItemFilesApi,
  downloadBoqItemFilesApi,
  bulkUpdateBoqItemsApi,
  updateItemCodeApi,
  updateItemHsnApi,
} from "../../services/api/boq/boqService";
import { api } from "../../utils/api";
import toast from "react-hot-toast";
import {
  FaFileExcel,
  FaFilePdf,
  FaEllipsisV,
  FaTruckMoving,
  FaTrash,
  FaEye,
  FaUpload,
  FaDownload,
  FaEdit,
} from "react-icons/fa";
import { MdOutlineAttachFile } from "react-icons/md";
import Modal from "react-modal";

export default function BoqView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const getExecutedQty = (item) => Number(item.executed_qty || 0);
  const getBalanceQty = (item) =>
    Number(item.quantity || 0) - getExecutedQty(item);

  const [boq, setBoq] = useState(null);
  const [items, setItems] = useState([]);
  const [files, setFiles] = useState([]);
  const [fileBlobs, setFileBlobs] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  // 2. Add HSN States
  const [hsnModal, setHsnModal] = useState(false);
  const [selectedItemForHsn, setSelectedItemForHsn] = useState(null);
  const [tempHsn, setTempHsn] = useState("");
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [itemFromDate, setItemFromDate] = useState("");
  const [itemToDate, setItemToDate] = useState("");

  // Execution history date range
  const [exeFromDate, setExeFromDate] = useState("");
  const [exeToDate, setExeToDate] = useState("");

  const [showExecutionModal, setShowExecutionModal] = useState(false);
  const [executedQty, setExecutedQty] = useState("");
  const [executionDate, setExecutionDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [showExecutionHistory, setShowExecutionHistory] = useState(false);
  const [executionHistory, setExecutionHistory] = useState([]);
  const [toDate, setToDate] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedHistoryItemId, setSelectedHistoryItemId] = useState("");
  const [activeHistoryItemId, setActiveHistoryItemId] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const [attachmentModal, setAttachmentModal] = useState(false);
  const [itemFiles, setItemFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [progress, setProgress] = useState(0);

  const [editItem, setEditItem] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);

  //item code modal
  const [showItemCodeModal, setShowItemCodeModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newItemCode, setNewItemCode] = useState("");

  const [dcNumber] = useState("1234");
  const dcType = "IN";
  const [descModal, setDescModal] = useState(false);
  const [selectedDesc, setSelectedDesc] = useState("");
  const [page, setPage] = useState(1);
  const perPage = 10;

  const [documentType, setDocumentType] = useState("");
  const [customType, setCustomType] = useState("");
  const location = useLocation();
  const currentBoqName = location.state?.boqName || "";
  const [openActionMenu, setOpenActionMenu] = useState(null);
  //dropdown selction for boq items files
  const documentTypes = [
    "TDS",
    "MIR",
    "IR",
    "Drawing",
    "Checklist",
    "Test Report",
    "Approval Copy",
    "Site Photo",
    "Invoice",
    "Measurement Sheet",
    "Completion Report",
    "Other",
  ];
  // const [toDate, setToDate] = useState("");

  /* ================= LOAD BOQ ================= */
  useEffect(() => {
    loadBoq();
  }, [id]);

  useEffect(() => {
    setHistory([]);
  }, [itemFromDate, itemToDate]);

  useEffect(() => {
    const closeMenu = () => setOpenActionMenu(null);
    document.addEventListener("click", closeMenu);
    return () => {
      document.removeEventListener("click", closeMenu);
    };
  }, []);

  const loadBoq = async () => {
    try {
      setLoading(true);
      const res = await fetchBoqById(id);

      if (res?.status && res?.data) {
        const data = res.data;
        setBoq(data);
        console.log("BOQ data:", data);
        setItems(Array.isArray(data.items) ? data.items : []);
        setFiles(Array.isArray(data.files) ? data.files : []);

        // fetch files as blobs for frontend protection
        const blobs = {};
        await Promise.all(
          data.files.map(async (file) => {
            try {
              const response = await api.get(`/${file.file_path}`, {
                responseType: "blob",
              });
              blobs[file.id] = URL.createObjectURL(response.data);
            } catch (err) {
              console.error("Error fetching file blob", file.file_name);
            }
          }),
        );
        setFileBlobs(blobs);
      } else {
        resetState();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load BOQ");
      resetState();
    } finally {
      setLoading(false);
    }
  };

  // const openAddExecutionItems = (id) => {
  //   navigate(`/boqs/${id}/items/create`);
  // };
  const openAddExecutionItems = (id) => {
    const nameToPass = boq?.boq?.boq_name || "";
    navigate(`/boqs/${id}/items/create`, {
      state: { boqName: nameToPass },
    });
  };
  const getExecutionPercent = (item) => {
    const executed = getExecutedQty(item);
    const total = item.quantity || 0;

    if (!total) return 0;

    return Math.min(100, Math.round((executed / total) * 100));
  };

  const openDescription = (desc) => {
    setSelectedDesc(desc);
    setDescModal(true);
  };

  const openAttachmentModal = async (item) => {
    setSelectedItem(item);
    setAttachmentModal(true);

    try {
      const res = await fetchBoqItemFilesApi(item.id);
      setItemFiles(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const openFile = async (id) => {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/boq-file/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (response.status === 401) {
      window.location.href = "/login";
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  };

  const getQtyChangeIndicator = (type) => {
    switch (type) {
      case "increased":
        return (
          <span className="text-green-600 font-medium flex items-center gap-1">
            ▲
          </span>
        );
      case "decreased":
        return (
          <span className="text-red-600 font-medium flex items-center gap-1">
            ▼
          </span>
        );
      case "same":
        return <span className="text-blue-600 text-xs">●</span>;
      case "no_history":
        return <span className="text-gray-400 text-xs">—</span>;
      default:
        return null;
    }
  };

  const openItemsHistory = async (itemId) => {
    try {
      setActiveHistoryItemId(itemId);
      setLoadingHistory(true);

      const res = await fetchHistoryBoqItem(itemId);
      setHistoryData(res || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingHistory(false);
    }
  };

  const closeHistoryModal = () => {
    setActiveHistoryItemId(false);
    setHistoryData([]);
  };

  const handleUploadFile = async () => {
    const finalDocumentType =
      documentType === "Other" ? customType : documentType;

    if (!selectedFile || !selectedItem) return;

    if (!finalDocumentType) {
      alert("Please select document type");
      return;
    }

    const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
    if (selectedFile.size > maxSize) {
      alert("File size should not exceed 10 MB");
      return;
    }

    setUploading(true);
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("document_type", finalDocumentType);

      await uploadBoqItemFileApi(selectedItem.id, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setProgress(percent);
        },
      });

      const res = await fetchBoqItemFilesApi(selectedItem.id);
      setItemFiles(res.data || []);

      setSelectedFile(null);
      setDocumentType("");
      setCustomType("");
    } catch (err) {
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleViewFile = async (id) => {
    try {
      const res = await viewBoqItemFilesApi(id);

      const file = new Blob([res.data], {
        type: res.headers["content-type"] || "application/pdf",
      });

      const fileURL = URL.createObjectURL(file);

      window.open(fileURL, "_blank");
    } catch (err) {
      console.error(err);
    }
  };

  const handleDownladFile = async (id) => {
    try {
      const res = await downloadBoqItemFilesApi(id);

      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // filename from backend header if available
      const contentDisposition = res.headers["content-disposition"];
      let fileName = "downloaded-file";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  //add item code for boqitems
  const handleSubmitItemCode = async () => {
    try {
      await updateItemCodeApi(selectedItem.id, {
        item_code: newItemCode,
      });

      toast.success("Item code added successfully");

      setShowItemCodeModal(false);

      loadBoq(); // refresh list
    } catch (error) {
      toast.error("Failed to add item code");
    }
  };

  // 3. Add the hsn code
  const handleUpdateHsn = async () => {
    if (!tempHsn) return toast.error("Please enter HSN code");
    const toastId = toast.loading("Adding HSN...");
    try {
      const res = await updateItemHsnApi(selectedItemForHsn.id, {
        hsn_code: tempHsn,
      });

      // Check for success (matches your API utility style)
      if (res.status === 200 || res.data?.status === "success") {
        toast.success("HSN Updated!", { id: toastId });
        setHsnModal(false);
        // Refresh data
        const refresh = await fetchBoqById(id);
        setBoq(refresh.data);
        setItems(refresh.data.items);
      }
    } catch (error) {
      const msg = error.response?.data?.message || "Permission Denied";
      toast.error(msg, { id: toastId });
    }
  };

  const filteredItems = items.filter((item) =>
    item.item_name?.toLowerCase().includes(search.toLowerCase()),
  );

  const paginatedItems = filteredItems.slice(
    (page - 1) * perPage,
    page * perPage,
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;

    setSearch(value);

    if (value.length > 0) {
      const filtered = items
        .filter((item) =>
          item.item_name?.toLowerCase().includes(value.toLowerCase()),
        )
        .slice(0, 5); // show top 5 suggestions

      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }

    setPage(1);
  };

  const resetState = () => {
    setBoq(null);
    setItems([]);
    setFiles([]);
    setFileBlobs({});
  };

  const filterHistoryByRange = async () => {
    if (!selectedHistoryItemId || !itemFromDate || !itemToDate) {
      toast.error("Select item and date range");
      return;
    }

    setHistoryLoading(true);

    try {
      const res = await api.get(`/boq/item-progress`, {
        params: {
          boq_item_id: selectedHistoryItemId,
          from_date: itemFromDate,
          to_date: itemToDate,
        },
      });
      setHistory(res.data.data || []);
    } catch {
      toast.error("Failed to filter history");
      setHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  /* ================= ITEM CHANGE ================= */
  const handleItemChange = (itemId, field, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, [field]: value } : item,
      ),
    );
    setDirty(true);
  };

  const openItemHistory = async (itemId) => {
    setShowHistory(true);
    setHistory([]);
    setSelectedHistoryItemId("");
    setItemFromDate("");
    setItemToDate("");

    try {
      const data = await fetchItemHistory(itemId);
      setHistory(Array.isArray(data) ? data : data?.data || []);
    } catch {
      toast.error("Failed to load item history");
      setHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const openAddExecution = (item) => {
    setSelectedItem(item);
    setExecutedQty("");
    setExecutionDate(new Date().toISOString().split("T")[0]);
    setRemarks("");
    setShowExecutionModal(true);
  };

  const closeExecutionModal = () => {
    setShowExecutionModal(false);
    setSelectedItem(null);
  };

  const submitExecution = async () => {
    if (!executedQty || executedQty <= 0) {
      toast.error("Enter valid executed quantity");
      return;
    }

    if (executedQty > getBalanceQty(selectedItem)) {
      toast.error("Executed qty cannot exceed balance qty");
      return;
    }

    try {
      setSaving(true);

      await addBoqItemExecution({
        boq_item_id: selectedItem.id,
        executed_qty: Number(executedQty),
        dc_type: dcType, // ✅ default value
        dc_no: dcNumber,
        entry_date: executionDate,
        remarks: remarks,
      });

      toast.success("Execution added successfully");
      closeExecutionModal();
      await loadBoq();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save execution");
    } finally {
      setSaving(false);
    }
  };

  const downloadFile = (fileId, fileName) => {
    const blobUrl = fileBlobs[fileId];
    if (!blobUrl) return toast.error("File not ready");

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    link.click();
  };

  const openDeleteModal = (itemId) => {
    setDeleteItemId(itemId);
    setShowDeleteModal(true);
  };

  const openExecutionHistory = (itemId) => {
    setSelectedItemId(itemId);
    setExecutionHistory([]);
    setItemFromDate("");
    setShowExecutionHistory(true);
  };

  //edit modal for item boq items
  const openEditModal = (item) => {
    // setSelectedBoq(item);
    setEditItem({
      id: item.id,
      item_name: item.item_name || "",
      item_code: item.item_code || "",
      description: item.description || "",
      unit: item.unit || "",
      quantity: item.quantity || "",
      new_quantity: item.new_quantity || item.quantity || "",
      rate: item.rate || "",
      scope: item.scope || "",
      approved_make: item.approved_make || "",
      offered_make: item.offered_make || "",
    });

    setEditModalOpen(true);
  };

  const handleEditChange = (field, value) => {
    setEditItem((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  //edit each item
  const handleSaveEdit = async () => {
    try {
      setSavingEdit(true);

      const payload = {
        items: [
          {
            id: editItem.id,
            item_name: editItem.item_name,
            description: editItem.description,
            unit: editItem.unit,
            quantity: editItem.quantity,
            new_quantity: editItem.new_quantity,
            rate: editItem.rate,
            scope: editItem.scope,
            approved_make: editItem.approved_make,
            offered_make: editItem.offered_make,
          },
        ],
      };

      await bulkUpdateBoqItemsApi(id, payload);
      const currentItem = items.find((i) => i.id === editItem.id);

      if (currentItem?.item_code !== editItem.item_code) {
        await updateItemCodeApi(editItem.id, {
          item_code: editItem.item_code,
        });
      }

      await loadBoq();

      toast.success("BOQ item updated successfully ✅");

      setEditModalOpen(false);
      setEditItem({});
    } catch (err) {
      console.error("Update failed:", err);
      toast.error("Failed to update BOQ item ❌");
    } finally {
      setSavingEdit(false);
    }
  };

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-gray-600">Loading BOQ...</p>
        </div>
      </div>
    );
  }

  if (!boq) return <p className="p-6 text-red-600">BOQ not found</p>;

  /* ================= RENDER ================= */
  return (
    <div className="p-4 md:p-6 bg-gray-100 min-h-screen">
      {/* Back */}
      <button
        onClick={() => navigate(-1)}
        className="mb-4 px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
      >
        ← Back
      </button>

      {/* BOQ HEADER */}
      <div className="bg-white rounded-2xl shadow-sm p-5 mb-6 flex flex-col md:flex-row md:justify-between gap-4">
        <div>
          <h2 className="text-xl md:text-2xl font-bold">{boq.boq.boq_name}</h2>
          <div className="flex flex-wrap gap-2 mt-2 text-sm text-gray-600">
            <span className="px-3 py-1 bg-gray-100 rounded-full">
              Discipline: <b>{boq.boq.discipline}</b>
            </span>
            <span className="px-3 py-1 bg-gray-100 rounded-full">
              BOQ ID: <b>{boq.boq.id}</b>
            </span>
          </div>
        </div>

        <div className="text-right">
          <span
            className={`inline-block px-3 py-1 rounded-full text-sm font-semibold
            ${
              boq.status === "approved"
                ? "bg-green-100 text-green-700"
                : boq.status === "draft"
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-red-100 text-red-700"
            }`}
          >
            {boq.boq.status.toUpperCase()}
          </span>
          <p className="text-xl font-bold mt-2">
            ₹ {Number(boq.boq.total_amount).toLocaleString()}
          </p>
          <p className="text-xs text-gray-500">Total Amount</p>
        </div>
      </div>

      {/* BOQ ITEMS */}
      <div className="bg-white rounded-xl shadow p-4 md:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
          {/* Title */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800">BOQ Items</h3>
            <p className="text-sm text-gray-500">
              Manage and track item changes
            </p>
          </div>

          <div className="relative w-full md:w-72">
            <input
              type="text"
              placeholder="Search item name..."
              value={search}
              onChange={handleSearchChange}
              onFocus={() => suggestions.length && setShowSuggestions(true)}
              className="border rounded-lg px-3 py-2 w-full text-sm"
            />

            {/* Suggestions Dropdown */}

            {showSuggestions && suggestions.length > 0 && (
              <div className="absolute left-0 right-0 bg-white border rounded-lg shadow mt-1 z-50">
                {suggestions.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      setSearch(item.item_name);
                      setShowSuggestions(false);
                    }}
                    className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                  >
                    {item.item_name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Action Button */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
            <button
              onClick={() => openAddExecutionItems(id)}
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow-sm transition"
            >
              Add Items
            </button>
            <button
              onClick={() => openItemHistory()}
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow-sm transition"
            >
              📅 Date-wise Execution History
            </button>
          </div>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block w-full border rounded-lg max-w-full">
          <div className="w-full overflow-x-auto overflow-y-visible relative">
            <table className="min-w-[1400px] w-full text-sm border-collapse">
              {/* HEADER */}
              <thead className="bg-gray-100 sticky top-0 z-20">
                <tr>
                  <th className="border px-3 py-2 w-[60px]">#</th>
                  <th className="border px-3 py-2 w-[180px]">Item/HSN Code</th>
                  <th className="border px-3 py-2 w-[220px]">Item Name</th>
                  <th className="border px-3 py-2 w-[320px]">Description</th>
                  <th className="border px-3 py-2 w-[80px]">Unit</th>
                  <th className="border px-3 py-2 w-[100px]">Updated Qty</th>
                  <th className="border px-3 py-2 w-[120px]">Rate</th>
                  <th className="border px-3 py-2 w-[150px]">Scope</th>
                  <th className="border px-3 py-2 w-[150px]">Approved</th>
                  <th className="border px-3 py-2 w-[150px]">Offered</th>

                  {/* Sticky Columns */}
                  <th className="border px-3 py-2 w-[100px] sticky right-[110px] bg-gray-100 z-20 shadow-[-4px_0_6px_rgba(0,0,0,0.08)]">
                    Executed
                  </th>

                  <th className="border px-3 py-2 w-[100px] sticky right-[40px] bg-gray-100 z-30">
                    Balance
                  </th>

                  <th className="border px-3 py-2 w-[50px] sticky right-0 bg-gray-100 z-30">
                    Actions
                  </th>
                </tr>
              </thead>

              {/* BODY */}
              <tbody>
                {paginatedItems.map((item, index) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="border px-3 py-2 text-center">
                      {(page - 1) * perPage + index + 1}
                    </td>

                    {/* Itemcode */}
                    <td className="border px-2 py-1 min-w-[180px]">
                      <div className="flex flex-wrap items-center gap-2 whitespace-nowrap">
                        {item.hsn_code ? (
                          item.hsn_code
                        ) : (
                          <button
                            onClick={() => {
                              setSelectedItemForHsn(item);
                              setTempHsn("");
                              setHsnModal(true);
                            }}
                            className="px-2 py-1 text-xs rounded bg-blue-50 text-blue-600 hover:bg-blue-100"
                          >
                            + Add HSN
                          </button>
                        )}
                        {item.item_code ? (
                          item.item_code
                        ) : (
                          <button
                            onClick={() => {
                              setSelectedItem(item);
                              setNewItemCode("");
                              setShowItemCodeModal(true);
                            }}
                            className="px-2 py-1 text-xs rounded bg-blue-50 text-blue-600 hover:bg-blue-100"
                          >
                            + Add Item Code
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Item Name */}
                    <td className="border px-2 py-1">
                      <input
                        type="text"
                        value={item.item_name ?? ""}
                        title={item.item_name ?? ""}
                        onChange={(e) =>
                          handleItemChange(item.id, "item_name", e.target.value)
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1 truncate"
                      />
                    </td>

                    {/* Description */}
                    <td className="border px-2 py-1">
                      <div className="flex items-start gap-2">
                        <span className="line-clamp-2 break-words">
                          {item.description}
                        </span>

                        {item.description?.length > 50 && (
                          <button
                            onClick={() => openDescription(item.description)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <FaEye />
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Unit */}
                    <td className="border px-2 py-1">
                      <input
                        type="text"
                        value={item.unit ?? ""}
                        onChange={(e) =>
                          handleItemChange(item.id, "unit", e.target.value)
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1"
                      />
                    </td>

                    <td className="border px-2 py-1">
                      <div className="flex flex-col">
                        <input
                          type="number"
                          value={item.final_quantity ?? item.quantity ?? ""}
                          onChange={(e) =>
                            handleItemChange(
                              item.id,
                              "final_quantity",
                              e.target.value,
                            )
                          }
                          disabled={!editMode}
                          className="w-full border rounded px-2 py-1"
                        />

                        {item.quantity && (
                          <div className="text-[11px] text-gray-500">
                            Old: {item.quantity}
                          </div>
                        )}

                        <div className="flex gap-10 text-xs mt-1">
                          {getQtyChangeIndicator(item.qty_change_type)}
                          <button
                            onClick={() => openItemsHistory(item.id)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <FaEye />
                          </button>
                        </div>
                      </div>
                    </td>

                    {activeHistoryItemId === item.id && (
                      <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
                        onClick={closeHistoryModal}
                      >
                        <div
                          className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden animate-fadeIn"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* Sticky Header */}
                          <div className="sticky top-0 bg-white z-10 flex justify-between items-center px-5 py-4 border-b">
                            <h2 className="text-lg font-semibold">
                              Item History (#{item.sn})
                            </h2>

                            <button
                              onClick={closeHistoryModal}
                              className="text-gray-500 hover:text-black text-lg"
                            >
                              ✕
                            </button>
                          </div>

                          {/* Body */}
                          <div className="p-5 max-h-[75vh] overflow-y-auto">
                            {loadingHistory ? (
                              <p className="text-center text-gray-500">
                                Loading...
                              </p>
                            ) : historyData.length === 0 ? (
                              <p className="text-center text-gray-500">
                                No history found
                              </p>
                            ) : (
                              <div className="relative border-l-2 border-gray-200 ml-3">
                                {[...historyData]
                                  .sort(
                                    (a, b) =>
                                      new Date(b.created_at) -
                                      new Date(a.created_at),
                                  )
                                  .map((h, index) => {
                                    const qtyIncrease =
                                      Number(h.new_quantity) >
                                      Number(h.old_quantity);

                                    const rateIncrease =
                                      Number(h.new_rate) > Number(h.old_rate);

                                    const qtyChanged =
                                      Number(h.new_quantity) !==
                                      Number(h.old_quantity);

                                    const rateChanged =
                                      Number(h.new_rate) !== Number(h.old_rate);

                                    return (
                                      <div
                                        key={h.id}
                                        className="mb-6 ml-6 relative"
                                      >
                                        {/* Timeline Dot */}
                                        <span className="absolute -left-9 top-2 w-4 h-4 bg-blue-500 rounded-full border-2 border-white"></span>

                                        {/* Card */}
                                        <div className="bg-white rounded-xl p-4 shadow border hover:shadow-lg transition">
                                          {/* Header */}
                                          <div className="flex justify-between items-center mb-3 flex-wrap gap-2">
                                            <span className="text-xs text-gray-400">
                                              Change #
                                              {historyData.length - index}
                                            </span>

                                            <div className="flex items-center gap-2">
                                              {index === 0 && (
                                                <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full font-medium">
                                                  Latest
                                                </span>
                                              )}

                                              <span className="text-xs text-gray-400">
                                                {new Date(
                                                  h.created_at,
                                                ).toLocaleString()}
                                              </span>
                                            </div>
                                          </div>

                                          {/* Quantity */}
                                          <div className="flex items-center gap-3 text-sm mb-2">
                                            <span className="font-medium w-16">
                                              Qty
                                            </span>

                                            <span className="px-2 py-1 bg-gray-100 rounded">
                                              {h.old_quantity}
                                            </span>

                                            <span className="text-gray-400">
                                              →
                                            </span>

                                            <span
                                              className={`px-2 py-1 rounded text-white ${
                                                qtyIncrease
                                                  ? "bg-green-500"
                                                  : "bg-red-500"
                                              }`}
                                            >
                                              {qtyIncrease ? "↑" : "↓"}{" "}
                                              {h.new_quantity}
                                            </span>
                                          </div>

                                          {/* Rate */}
                                          <div className="flex items-center gap-3 text-sm mb-2">
                                            <span className="font-medium w-16">
                                              Rate
                                            </span>

                                            <span className="px-2 py-1 bg-gray-100 rounded">
                                              ₹
                                              {Number(
                                                h.old_rate,
                                              ).toLocaleString()}
                                            </span>

                                            <span className="text-gray-400">
                                              →
                                            </span>

                                            <span
                                              className={`px-2 py-1 rounded text-white ${
                                                rateIncrease
                                                  ? "bg-green-500"
                                                  : "bg-red-500"
                                              }`}
                                            >
                                              {rateIncrease ? "↑" : "↓"} ₹
                                              {Number(
                                                h.new_rate,
                                              ).toLocaleString()}
                                            </span>
                                          </div>

                                          {/* Reason */}
                                          <div className="text-xs text-gray-500 mb-1">
                                            📝{" "}
                                            {h.change_reason ||
                                              "No reason provided"}
                                          </div>

                                          {/* Changed By */}
                                          {/* <div className="text-xs text-gray-400">
                                            👤 {getUserName(h.changed_by)}
                                          </div> */}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Rate */}
                    <td className="border px-2 py-1">
                      <input
                        type="number"
                        value={item.rate ?? ""}
                        onChange={(e) =>
                          handleItemChange(item.id, "rate", e.target.value)
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1"
                      />
                    </td>

                    {/* Scope */}
                    <td className="border px-2 py-1">
                      <input
                        type="text"
                        value={item.scope ?? ""}
                        onChange={(e) =>
                          handleItemChange(item.id, "scope", e.target.value)
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1"
                      />
                    </td>

                    {/* Approved */}
                    <td className="border px-2 py-1">
                      <input
                        type="text"
                        value={item.approved_make ?? ""}
                        onChange={(e) =>
                          handleItemChange(
                            item.id,
                            "approved_make",
                            e.target.value,
                          )
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1"
                      />
                    </td>

                    {/* Offered */}
                    <td className="border px-2 py-1">
                      <input
                        type="text"
                        value={item.offered_make ?? ""}
                        onChange={(e) =>
                          handleItemChange(
                            item.id,
                            "offered_make",
                            e.target.value,
                          )
                        }
                        disabled={!editMode}
                        className="w-full border rounded px-2 py-1"
                      />
                    </td>

                    {/* Executed */}
                    <td className="border px-2 py-2 text-center sticky right-[110px] border-l border-white bg-gray-100 shadow-[-4px_0_6px_rgba(0,0,0,0.06)]">
                      {getExecutedQty(item)}
                    </td>

                    {/* Balance */}
                    <td className="border px-2 py-2 text-center sticky right-[40px] border-l border-white bg-gray-100 shadow-[-4px_0_6px_rgba(0,0,0,0.06)]">
                      {getBalanceQty(item)}
                    </td>

                    {/* Actions */}
                    <td
                      className={`border px-2 py-2 text-center sticky right-0 border-l border-white bg-gray-100 shadow-[-4px_0_6px_rgba(0,0,0,0.06)] relative overflow-visible ${
                        openActionMenu === item.id ? "z-[9999]" : "z-30"
                      }`}
                    >
                      {" "}
                      <div className="relative flex justify-center">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenActionMenu(
                              openActionMenu === item.id ? null : item.id,
                            );
                          }}
                          className="text-gray-600 hover:text-black"
                        >
                          <FaEllipsisV />
                        </button>

                        {openActionMenu === item.id && (
                          <div
                            className="absolute right-0 top-full mt-2 w-52 bg-white rounded-xl shadow-2xl border border-gray-200 z-[99999] overflow-hidden animate-fadeIn"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              onClick={() => {
                                openAddExecution(item);
                                setOpenActionMenu(null);
                              }}
                              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-green-600 hover:bg-green-50 transition"
                            >
                              <span>➕</span>
                              <span>Add Execution</span>
                            </button>

                            <button
                              onClick={() => {
                                openEditModal(item);
                                setOpenActionMenu(null);
                              }}
                              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-yellow-600 hover:bg-yellow-50 transition"
                            >
                              <FaEdit />
                              <span>Edit Item</span>
                            </button>

                            <button
                              onClick={() => {
                                openDeleteModal(item.id);
                                setOpenActionMenu(null);
                              }}
                              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition"
                            >
                              <FaTrash />
                              <span>Delete Item</span>
                            </button>

                            <button
                              onClick={() => {
                                openAttachmentModal(item);
                                setOpenActionMenu(null);
                              }}
                              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-blue-600 hover:bg-blue-50 transition"
                            >
                              <MdOutlineAttachFile />
                              <span>Attachment</span>
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* PAGINATION */}

        <div className="flex justify-center md:justify-end gap-2 mt-6">
          <button
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>

          <span className="px-3 py-1">
            Page {page} of {Math.ceil(filteredItems.length / perPage)}
          </span>

          <button
            onClick={() => setPage(page + 1)}
            disabled={page * perPage >= filteredItems.length}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4 px-3 pb-4">
          {paginatedItems.map((item, index) => {
            const percent = getExecutionPercent(item);

            return (
              <div
                key={item.id}
                className="bg-white rounded-2xl border shadow-sm overflow-hidden"
              >
                {/* Header */}
                <div className="p-4 bg-gradient-to-r from-gray-50 to-white border-b">
                  <div className="flex justify-between items-start">
                    <div className="flex-1 min-w-0">
                      <p className="text-[11px] text-gray-400">
                        Item #{(page - 1) * perPage + index + 1}
                      </p>

                      <p className="font-semibold text-sm text-gray-900 truncate">
                        {item.item_name}
                      </p>

                      <div className="mt-1 flex flex-wrap gap-2">
                        {item.item_code ? (
                          <span className="px-2 py-1 text-[11px] rounded bg-blue-50 text-blue-600">
                            {item.item_code}
                          </span>
                        ) : (
                          <button
                            onClick={() => {
                              setSelectedItem(item);
                              setNewItemCode("");
                              setShowItemCodeModal(true);
                            }}
                            className="px-2 py-1 text-[11px] rounded bg-blue-50 text-blue-600"
                          >
                            + Add Code
                          </button>
                        )}

                        <span className="px-2 py-1 text-[11px] rounded bg-gray-100 text-gray-600">
                          {item.unit}
                        </span>
                      </div>
                    </div>

                    {/* Action Menu */}
                    <div className="relative ml-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenActionMenu(
                            openActionMenu === item.id ? null : item.id,
                          );
                        }}
                        className="p-2 rounded-full hover:bg-gray-100"
                      >
                        <FaEllipsisV />
                      </button>

                      {openActionMenu === item.id && (
                        <div className="absolute right-0 mt-2 w-52 bg-white rounded-xl shadow-xl border z-50">
                          <button
                            onClick={() => {
                              openAddExecution(item);
                              setOpenActionMenu(null);
                            }}
                            className="flex items-center gap-3 w-full px-4 py-3 text-sm text-green-600 hover:bg-green-50"
                          >
                            ➕ Add Execution
                          </button>

                          <button
                            onClick={() => {
                              openEditModal(item);
                              setOpenActionMenu(null);
                            }}
                            className="flex items-center gap-3 w-full px-4 py-3 text-sm text-yellow-600 hover:bg-yellow-50"
                          >
                            <FaEdit /> Edit Item
                          </button>

                          <button
                            onClick={() => {
                              openDeleteModal(item.id);
                              setOpenActionMenu(null);
                            }}
                            className="flex items-center gap-3 w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50"
                          >
                            <FaTrash /> Delete Item
                          </button>

                          <button
                            onClick={() => {
                              openAttachmentModal(item);
                              setOpenActionMenu(null);
                            }}
                            className="flex items-center gap-3 w-full px-4 py-3 text-sm text-blue-600 hover:bg-blue-50"
                          >
                            <MdOutlineAttachFile /> Attachment
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Description */}
                  <div className="mt-3 flex items-start gap-2">
                    <p className="text-xs text-gray-500 line-clamp-2">
                      {item.description}
                    </p>

                    {item.description?.length > 60 && (
                      <button
                        onClick={() => openDescription(item.description)}
                        className="text-blue-600"
                      >
                        <FaEye />
                      </button>
                    )}
                  </div>
                </div>

                {/* Main Body */}
                <div className="p-4 space-y-4">
                  {/* Qty + Rate */}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <p className="text-gray-400 text-xs">Quantity</p>

                      <button
                        onClick={() => openItemsHistory(item)}
                        className="w-full border rounded-xl px-3 py-2 text-left bg-white shadow-sm"
                      >
                        {item.new_quantity ?? item.quantity ?? ""}
                      </button>

                      {item.quantity && (
                        <div className="text-[11px] text-gray-500">
                          Old: {item.quantity}
                        </div>
                      )}

                      <div className="flex items-center justify-between text-xs">
                        <div>{getQtyChangeIndicator(item.qty_change_type)}</div>

                        <button
                          onClick={() => openItemsHistory(item.id)}
                          className="text-blue-600"
                        >
                          <FaEye />
                        </button>
                        {activeHistoryItemId === item.id && (
                          <div
                            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
                            onClick={closeHistoryModal}
                          >
                            <div
                              className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden animate-fadeIn"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Sticky Header */}
                              <div className="sticky top-0 bg-white z-10 flex justify-between items-center px-5 py-4 border-b">
                                <h2 className="text-lg font-semibold">
                                  Item History (#{item.sn})
                                </h2>

                                <button
                                  onClick={closeHistoryModal}
                                  className="text-gray-500 hover:text-black text-lg"
                                >
                                  ✕
                                </button>
                              </div>

                              {/* Body */}
                              <div className="p-5 max-h-[75vh] overflow-y-auto">
                                {loadingHistory ? (
                                  <p className="text-center text-gray-500">
                                    Loading...
                                  </p>
                                ) : historyData.length === 0 ? (
                                  <p className="text-center text-gray-500">
                                    No history found
                                  </p>
                                ) : (
                                  <div className="relative border-l-2 border-gray-200 ml-3">
                                    {[...historyData]
                                      .reverse()
                                      .map((h, index) => {
                                        const qtyIncrease =
                                          Number(h.new_quantity) >
                                          Number(h.quantity);

                                        const rateIncrease =
                                          Number(h.new_rate) >
                                          Number(h.old_rate);

                                        return (
                                          <div
                                            key={h.id}
                                            className="mb-6 ml-6 relative"
                                          >
                                            {/* Timeline Dot */}
                                            <span className="absolute -left-9 top-2 w-4 h-4 bg-blue-500 rounded-full border-2 border-white"></span>

                                            {/* Card */}
                                            <div className="bg-gray-50 rounded-xl p-4 shadow-sm border hover:shadow-md transition">
                                              {/* Top Row */}
                                              <div className="flex justify-between items-center mb-3 flex-wrap gap-2">
                                                <span className="text-xs text-gray-400">
                                                  Change #
                                                  {historyData.length - index}
                                                </span>

                                                <span className="text-xs text-gray-400">
                                                  {new Date(
                                                    h.created_at,
                                                  ).toLocaleString()}
                                                </span>
                                              </div>

                                              {/* Quantity */}
                                              <div className="flex flex-wrap items-center gap-2 text-sm mb-2">
                                                <span className="font-medium min-w-[50px]">
                                                  Qty
                                                </span>

                                                <span className="px-2 py-1 bg-gray-200 rounded">
                                                  {h.quantity}
                                                </span>

                                                <span>➡</span>

                                                <span
                                                  className={`px-2 py-1 rounded text-white ${
                                                    qtyIncrease
                                                      ? "bg-green-500"
                                                      : "bg-red-500"
                                                  }`}
                                                >
                                                  {h.new_quantity}
                                                </span>
                                              </div>

                                              {/* Rate */}
                                              <div className="flex flex-wrap items-center gap-2 text-sm mb-2">
                                                <span className="font-medium min-w-[50px]">
                                                  Rate
                                                </span>

                                                <span className="px-2 py-1 bg-gray-200 rounded">
                                                  ₹{h.old_rate}
                                                </span>

                                                <span>➡</span>

                                                <span
                                                  className={`px-2 py-1 rounded text-white ${
                                                    rateIncrease
                                                      ? "bg-green-500"
                                                      : "bg-red-500"
                                                  }`}
                                                >
                                                  ₹{h.new_rate}
                                                </span>
                                              </div>

                                              {/* Reason */}
                                              <div className="text-xs text-gray-500 mb-2">
                                                Reason:{" "}
                                                {h.change_reason ||
                                                  "No reason provided"}
                                              </div>

                                              {/* Changed By */}
                                              <div className="text-xs text-gray-400">
                                                Changed By: User #{h.changed_by}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div>
                      <p className="text-xs text-gray-400 mb-1">Rate</p>
                      <input
                        type="number"
                        value={item.rate ?? ""}
                        onChange={(e) =>
                          handleItemChange(item.id, "rate", e.target.value)
                        }
                        disabled={!editMode}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      />
                    </div>
                  </div>

                  {/* Progress */}
                  <div>
                    <div className="flex justify-between text-xs mb-1">
                      <span>Executed {percent}%</span>
                      <span>Balance {getBalanceQty(item)}</span>
                    </div>

                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-2 bg-green-500 rounded-full transition-all"
                        style={{ width: `${percent}%` }}
                      />
                    </div>
                  </div>

                  {/* Expand Button */}
                  <button
                    onClick={() =>
                      setExpandedItem(expandedItem === item.id ? null : item.id)
                    }
                    className="text-blue-600 text-xs font-medium"
                  >
                    {expandedItem === item.id
                      ? "Hide Details ▲"
                      : "View Details ▼"}
                  </button>
                </div>

                {/* Expanded */}
                {expandedItem === item.id && (
                  <div className="border-t bg-gray-50 p-4 space-y-3">
                    <input
                      type="text"
                      value={item.scope ?? ""}
                      onChange={(e) =>
                        handleItemChange(item.id, "scope", e.target.value)
                      }
                      placeholder="Scope"
                      disabled={!editMode}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                    />

                    <input
                      type="text"
                      value={item.approved_make ?? ""}
                      onChange={(e) =>
                        handleItemChange(
                          item.id,
                          "approved_make",
                          e.target.value,
                        )
                      }
                      placeholder="Approved"
                      disabled={!editMode}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                    />

                    <input
                      type="text"
                      value={item.offered_make ?? ""}
                      onChange={(e) =>
                        handleItemChange(
                          item.id,
                          "offered_make",
                          e.target.value,
                        )
                      }
                      placeholder="Offered"
                      disabled={!editMode}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                    />

                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div className="bg-white rounded-lg border p-3 text-center">
                        <p className="text-xs text-gray-400">Executed</p>
                        <p className="font-semibold">{getExecutedQty(item)}</p>
                      </div>

                      <div className="bg-white rounded-lg border p-3 text-center">
                        <p className="text-xs text-gray-400">Balance</p>
                        <p className="font-semibold">{getBalanceQty(item)}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* //add item code modal popup */}
      {showItemCodeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-[400px] p-6">
            <h2 className="text-lg font-semibold mb-4">Add Item Code</h2>

            <div className="mb-3">
              <label className="text-sm text-gray-600">BOQ Item Name</label>
              <div className="font-medium">{selectedItem?.item_name}</div>
            </div>

            <div className="mb-4">
              <label className="text-sm text-gray-600">Item Code</label>
              <input
                type="text"
                value={newItemCode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z0-9/-]/g, "");
                  setNewItemCode(value);
                }}
                placeholder="Enter item code"
                className="w-full border rounded px-3 py-2 mt-1"
              />
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowItemCodeModal(false)}
                className="px-4 py-2 rounded border"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmitItemCode}
                className="px-4 py-2 rounded bg-blue-600 text-white"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {editModalOpen && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold">Edit BOQ Item</h2>
              <button onClick={() => setEditModalOpen(false)}>✕</button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                value={editItem?.item_code}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z0-9/-]/g, "");
                  handleEditChange("item_code", value);
                }}
                className="border rounded px-3 py-2"
                placeholder="Item Code"
              />

              <input
                value={editItem?.item_name}
                onChange={(e) => handleEditChange("item_name", e.target.value)}
                className="border rounded px-3 py-2"
                placeholder="Item Name"
              />

              <input
                value={editItem?.unit}
                onChange={(e) => handleEditChange("unit", e.target.value)}
                className="border rounded px-3 py-2"
                placeholder="Unit"
              />

              <input
                type="number"
                value={editItem?.quantity}
                onChange={(e) => handleEditChange("quantity", e.target.value)}
                className="border rounded px-3 py-2"
                placeholder="Quantity"
              />

              <input
                type="number"
                value={editItem?.new_quantity}
                onChange={(e) =>
                  handleEditChange("new_quantity", e.target.value)
                }
                className="border rounded px-3 py-2"
                placeholder="Updated Quantity"
              />

              <input
                type="number"
                value={editItem?.rate}
                onChange={(e) => handleEditChange("rate", e.target.value)}
                className="border rounded px-3 py-2"
                placeholder="Rate"
              />

              <input
                value={editItem?.scope}
                onChange={(e) => handleEditChange("scope", e.target.value)}
                className="border rounded px-3 py-2"
                placeholder="Scope"
              />

              <input
                value={editItem?.approved_make}
                onChange={(e) =>
                  handleEditChange("approved_make", e.target.value)
                }
                className="border rounded px-3 py-2"
                placeholder="Approved Make"
              />

              <input
                value={editItem?.offered_make}
                onChange={(e) =>
                  handleEditChange("offered_make", e.target.value)
                }
                className="border rounded px-3 py-2"
                placeholder="Offered Make"
              />

              <textarea
                value={editItem?.description}
                onChange={(e) =>
                  handleEditChange("description", e.target.value)
                }
                rows={4}
                className="border rounded px-3 py-2 md:col-span-2"
                placeholder="Description"
              />
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setEditModalOpen(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleSaveEdit}
                disabled={savingEdit}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                {savingEdit ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={descModal}
        onRequestClose={() => setDescModal(false)}
        className="bg-white p-6 rounded shadow-lg max-w-2xl mx-auto mt-20 z-[80]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-[70]"
      >
        <h2 className="text-lg font-semibold mb-4">Item Description</h2>

        <p className="text-gray-700 whitespace-pre-line">{selectedDesc}</p>

        <div className="mt-4 text-right">
          <button
            onClick={() => setDescModal(false)}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Close
          </button>
        </div>
      </Modal>

      {showHistory && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white w-full max-w-4xl rounded-xl p-6 shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Item History</h3>
              <p className="text-xs text-gray-500">
                Showing all BOQ item changes
              </p>
              <button onClick={() => setShowHistory(false)}>✕</button>
            </div>

            {/* Date Range Filter */}
            <div className="flex flex-wrap gap-3 mb-4">
              <select
                value={selectedHistoryItemId}
                onChange={(e) => setSelectedHistoryItemId(e.target.value)}
                className="border rounded px-3 py-2 w-[100%]"
              >
                <option value="">Select BOQ Item</option>
                {items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.item_name}
                  </option>
                ))}
              </select>

              <input
                type="date"
                value={itemFromDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setItemFromDate(e.target.value)}
                className="border rounded px-3 py-2"
              />

              <input
                type="date"
                value={itemToDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setItemToDate(e.target.value)}
                className="border rounded px-3 py-2"
              />

              <button
                onClick={filterHistoryByRange}
                className="bg-blue-600 text-white px-4 rounded"
              >
                Filter Range
              </button>
            </div>

            {/* History Table */}
            {historyLoading ? (
              <p className="text-sm text-gray-500">Loading history...</p>
            ) : history.length === 0 ? (
              <p className="text-sm text-gray-500">No history found</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm border">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2">ID</th>
                      <th className="border px-3 py-2">BOQ Item ID</th>
                      <th className="border px-3 py-2">Executed Qty</th>
                      <th className="border px-3 py-2">Entry Date</th>
                      <th className="border px-3 py-2">DC Type</th>
                      <th className="border px-3 py-2">DC No</th>
                      <th className="border px-3 py-2">Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {history.length > 0 ? (
                      history.map((h, index) => (
                        <tr key={h.id} className="text-center">
                          <td className="border px-3 py-2">{index + 1}</td>
                          <td className="border px-3 py-2">{h.boq_item_id}</td>
                          <td className="border px-3 py-2">{h.executed_qty}</td>
                          <td className="border px-3 py-2">{h.entry_date}</td>
                          <td className="border px-3 py-2">
                            {h.dc_type || "-"}
                          </td>
                          <td className="border px-3 py-2">{h.dc_no || "-"}</td>
                          <td className="border px-3 py-2">
                            {h.remarks || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="7"
                          className="text-center py-4 text-gray-500"
                        >
                          No execution history found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {showExecutionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-3">
          <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold">Add Execution</h2>
              <button
                onClick={closeExecutionModal}
                className="text-gray-500 text-xl hover:text-black"
              >
                ✕
              </button>
            </div>

            {/* Item info */}
            <div className="bg-gray-50 p-4 rounded text-sm mb-6">
              <p>
                <b>Description:</b> {selectedItem.description}
              </p>
              <p className="mt-1">
                <b>Balance Qty:</b>{" "}
                <span className="text-green-600 font-semibold">
                  {getBalanceQty(selectedItem)}
                </span>
              </p>
            </div>

            {/* Form Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Executed Qty */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Executed Quantity
                </label>
                <input
                  type="number"
                  value={executedQty}
                  onChange={(e) => setExecutedQty(e.target.value)}
                  className="w-full border rounded px-3 py-2 text-sm"
                  placeholder="Enter executed qty"
                />
              </div>

              {/* Execution Date */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Execution Date
                </label>
                <input
                  type="date"
                  value={executionDate}
                  onChange={(e) => setExecutionDate(e.target.value)}
                  className="w-full border rounded px-3 py-2 text-sm"
                />
              </div>
            </div>

            {/* Remarks (full width) */}
            <div className="mt-4">
              <label className="block text-sm font-medium mb-1">Remarks</label>
              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                rows="3"
                className="w-full border rounded px-3 py-2 text-sm"
                placeholder="Optional"
              />
            </div>

            {/* Actions */}
            <div className="flex gap-3 justify-end mt-6">
              <button
                onClick={closeExecutionModal}
                className="px-4 py-2 text-sm border rounded"
              >
                Cancel
              </button>

              <button
                onClick={submitExecution}
                disabled={saving}
                className="px-4 py-2 text-sm bg-green-600 text-white rounded disabled:opacity-50"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showExecutionHistory && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-3">
          <div className="bg-white w-full max-w-5xl rounded-xl p-6 shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Execution History</h3>
              <p className="text-xs text-gray-500">Item ID: {selectedItemId}</p>
              <button onClick={() => setShowExecutionHistory(false)}>✕</button>
            </div>

            {/* Date Filter */}
            <div className="flex flex-wrap gap-3 mb-4">
              <input
                type="date"
                value={itemFromDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setItemFromDate(e.target.value)}
                className="border rounded px-3 py-2"
              />

              <input
                type="date"
                value={itemToDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setItemToDate(e.target.value)}
                className="border rounded px-3 py-2"
              />

              <button
                onClick={filterHistoryByRange}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Filter Range
              </button>
            </div>

            {/* Table */}
            {historyLoading ? (
              <p className="text-sm text-gray-500">
                Loading execution history...
              </p>
            ) : executionHistory.length === 0 ? (
              <p className="text-sm text-gray-500">No execution found</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm border">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2">Date</th>
                      <th className="border px-3 py-2">DC Type</th>
                      <th className="border px-3 py-2">DC No</th>
                      <th className="border px-3 py-2">Executed Qty</th>
                      <th className="border px-3 py-2">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {executionHistory.map((h) => (
                      <tr key={h.id}>
                        <td className="border px-3 py-2">
                          {new Date(h.entry_date).toLocaleDateString()}
                        </td>

                        <td className="border px-3 py-2">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold
                      ${
                        h.dc_type === "IN"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                          >
                            DC {h.dc_type}
                          </span>
                        </td>

                        <td className="border px-3 py-2">{h.dc_no}</td>
                        <td className="border px-3 py-2">{h.executed_qty}</td>
                        <td className="border px-3 py-2">{h.remarks || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-3">
          <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">
            <h2 className="text-lg font-semibold mb-4">Delete Item</h2>
            <p>Are you sure you want to delete this item?</p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  if (!deleteItemId) return;

                  try {
                    setSaving(true);
                    await deleteBoqItem(deleteItemId); // call service
                    setItems((prev) =>
                      prev.filter((item) => item.id !== deleteItemId),
                    );
                    toast.success("Item deleted successfully");
                  } catch (err) {
                    toast.error("Failed to delete item");
                  } finally {
                    setSaving(false);
                    setShowDeleteModal(false);
                    setDeleteItemId(null);
                  }
                }}
                className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {attachmentModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-[800px] p-6 shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Attachment Files</h2>

            {/* Item Dropdown */}
            <select
              value={selectedItem?.id || ""}
              className="w-full border rounded px-3 py-2 mb-4"
              disabled
            >
              <option>{selectedItem?.item_name}</option>
            </select>

            {/* Document Type Dropdown */}
            <select
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
              className="w-full border rounded px-3 py-2 mb-4"
            >
              <option value="">Select Option</option>

              {documentTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>

            {/* Custom Type Input */}
            {documentType === "Other" && (
              <input
                type="text"
                placeholder="Enter document type"
                value={customType}
                onChange={(e) => setCustomType(e.target.value)}
                className="w-full border rounded px-3 py-2 mb-4"
              />
            )}

            {/* Upload */}
            <div className="flex gap-3 mb-4">
              <input
                type="file"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                className="border rounded px-3 py-2 w-full"
              />

              <button
                onClick={handleUploadFile}
                disabled={uploading}
                className={`relative overflow-hidden bg-blue-600 text-white px-4 py-2 rounded w-36 ${
                  uploading ? "cursor-not-allowed opacity-70" : ""
                }`}
              >
                {/* Progress bar overlay */}
                {uploading && (
                  <div
                    className="absolute top-0 left-0 h-full bg-blue-400 opacity-50 z-0 transition-all duration-300"
                    style={{ width: `${progress}%` }}
                  ></div>
                )}

                {/* Button text */}
                <span className="relative z-10">
                  {uploading ? `Uploading ${progress}%` : "Upload"}
                </span>
              </button>
            </div>

            {/* Files Table */}
            <table className="w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border px-3 py-2">#</th>
                  <th className="border px-3 py-2">File Name</th>
                  <th className="border px-3 py-2">Document Type</th>
                  <th className="border px-3 py-2">Approval Status</th>
                  <th className="border px-3 py-2">Approval Date</th>
                  <th className="border px-3 py-2">Approved By</th>
                  <th className="border px-3 py-2">Action</th>
                </tr>
              </thead>

              <tbody>
                {itemFiles.length > 0 ? (
                  itemFiles.map((file, index) => (
                    <tr key={file.id} className="text-center">
                      <td className="border px-3 py-2">{index + 1}</td>
                      <td className="border px-3 py-2">{file.file_name}</td>
                      <td className="border px-3 py-2">{file.document_type}</td>
                      <td className="border px-3 py-2">
                        {file.approval_status}
                      </td>
                      <td className="border px-3 py-2">
                        {file.approved_at || "N/A"}
                      </td>
                      <td className="border px-3 py-2">
                        {file.approved_by || "N/A"}
                      </td>
                      <td className="border px-3 py-2">
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleViewFile(file.id)}
                            className="px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
                            title="View File"
                          >
                            <FaEye size={12} />
                          </button>

                          <button
                            onClick={() => handleDownladFile(file.id)}
                            className="px-2 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200"
                            title="Download File"
                          >
                            <FaDownload size={12} />
                          </button>
                        </div>
                        {/* <button
                          onClick={() => openFile(file.id)}
                          className="text-blue-600 underline"
                        >
                          View
                        </button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4">
                      No files uploaded
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Footer */}
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setAttachmentModal(false)}
                className="px-4 py-2 border rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* HSN CODE MODAL */}
      {hsnModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm border overflow-hidden">
            <div className="bg-gray-50 p-4 border-b">
              <h3 className="font-bold text-gray-700">Add HSN Code</h3>
              <div className="mb-3">
                <label className="text-sm text-gray-600">BOQ Item Name</label>
                <div className="font-medium">
                  {selectedItemForHsn?.item_name}
                </div>
              </div>
            </div>

            <div className="p-6">
              <label className="text-xs font-semibold text-gray-600 mb-2 block uppercase tracking-wider">
                HSN Code
              </label>
              <input
                type="text"
                className="w-full border-2 border-gray-200 p-3 rounded-lg focus:border-blue-500 outline-none transition-colors"
                placeholder="Enter HSN (e.g. 8481)"
                value={tempHsn}
                onChange={(e) => setTempHsn(e.target.value)}
                autoFocus
              />
            </div>

            <div className="flex p-4 bg-gray-50 gap-3">
              <button
                onClick={() => setHsnModal(false)}
                className="flex-1 px-4 py-2 text-gray-600 font-medium hover:bg-gray-200 rounded-lg transition"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateHsn}
                className="flex-1 px-4 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition shadow-lg shadow-blue-200"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
